// extracted by mini-css-extract-plugin
var _1 = "OA4m0s6nzo";
var _2 = "EsKc51VHSf";
var _3 = "nKl1kkuC4_";
var _4 = "bcP4F5lyIo";
var _5 = "KUZZp27fxM";
var _6 = "C83l6hdkpY";
var _7 = "oMXBhs8PDQ";
export { _1 as "root", _2 as "size1", _3 as "size10", _4 as "size2", _5 as "size3", _6 as "size4", _7 as "size5" }
